import React, { useState, useEffect } from 'react';
import { mergeStyleSets } from '@fluentui/react';
import { DetailsList, GroupHeader, GroupedList, DetailsRow, SelectionMode, DetailsListLayoutMode } from '@fluentui/react';
import { simpleDeepCopy } from 'shared/utils/utils';
import { omit } from 'shared/utils/utils';

const styles = mergeStyleSets({

});

export const ItemAction = {
  Delete: 'delete',
  Update: 'update',
  Reorder: 'reorder',
};

const RichList = (props) => {
  const {
    editMode,
    getParentId,
    items: initialItems,
    modifiedItems,
    onItemsChanged,
    onItemsOrderChanged,
    onRenderItem,
    groupHeaderProps,
    ...otherProps
  } = props;

  const [dragState, setDragState] = useState({});

  let index = 0;
  const groups = initialItems
    .map(group => {
      const g = { key: group.id, name: group.name, id: group.id, startIndex: index, count: group.children.length, level: 0,
        isGroup: true, isCollapsed: group.isCollapsed
      };
      index += g.count;
      return g;
    })
    .filter(x => !!x.count);

  const items = initialItems.flatMap(x => x.children);

  const handleItemChangedImpl = (item, action) => {
    const newModifiedItems = modifiedItems.filter(x => x.item.id !== item.id);
    newModifiedItems.push({ item, action });

    const items = simpleDeepCopy(initialItems);
    const parent = items.find(x => x.id === getParentId(item));
    const { children } = parent;
    const itemIndex = children.findIndex(x => x.id === item.id);

    if (action === ItemAction.Delete) {
      children.splice(itemIndex, 1);
    }
    else {
      children[itemIndex] = item;
    }

    onItemsChanged(items, newModifiedItems);
  }

  const handleItemChanged = (item) => {
    handleItemChangedImpl(item, ItemAction.Update);
  };

  const handleItemRemoved = (item) => {
    handleItemChangedImpl(item, ItemAction.Delete);
  };

  const dragDropEvents = {
    canDrop: (dropContext, dragContext) => {
      const dropItem = dropContext.data;
      const dragItem = dragState.item;

      const canDrop = !dropItem.isGroup && (!dragItem || (getParentId(dragItem) === getParentId(dropItem) && dragItem.id !== dropItem.id));
      console.log('canDrop: ', dropContext, dragContext, dragState, canDrop);
      return canDrop;
    },
    canDrag: (item) => {
      return !item.isGroup;
    },
    canDragGroups: () => false,

    onDragEnter: (item, event) => {

    },
    onDragLeave: (item, event) => {

    },
    onDrop: (item, event) => {
      // console.log('On Drop: ', item, dragState);
      event.preventDefault();

      const { item: dragItem } = dragState;
      // console.log('On Drop. Dropping: ', dragItem, initialItems);

      const newItems = simpleDeepCopy(initialItems);
      // console.log('On Drop. Copy: ', newItems);

      const parent = newItems.find(x => x.id === getParentId(dragItem));
      const { children } = parent;
      const insertIndex = children.findIndex(x => x.id === item.id);
      const newChildren = children.filter(x => x.id !== dragItem.id);
      newChildren.splice(insertIndex, 0, dragItem);
      parent.children = newChildren;

      // console.log('On drop. Dropped. New order: ', newItems);

      onItemsOrderChanged(parent, item);
      onItemsChanged(newItems, modifiedItems);

    },
    onDragStart: (item, index, selectedItems, event) => {
      // console.log('Drag start: ', item, index);
      setDragState({ item, index });
    },
    onDragEnd: (item, event) => {
      // console.log('Drag end', item);
      setDragState({});
    }
  };

  const columns = [
    { key: 'items', name: 'Items', fieldName: 'item',
      // onRender: (item, index, column) => onRenderItem(item, handleItemChanged, handleItemRemoved)
    }
  ];

  // GroupList
  const onRenderCell = (nestingDepth, item, itemIndex) => {
    return onRenderItem(item, handleItemChanged, handleItemRemoved);
  };

  const { onCollapseChanged, onRenderTitle: onRenderGroupTitle, iconName: groupIconName, onRenderGroupHeader } = groupHeaderProps;

  const onToggleCollapse = (group) => {
    const items = simpleDeepCopy(initialItems);
    items.find(x => x.id === group.id).isCollapsed = !group.isCollapsed;
    onCollapseChanged && onCollapseChanged(items);
  };

  const onRenderHeader = (groupHeaderProps) => {
    return !onRenderGroupHeader
      ? (<GroupHeader {...groupHeaderProps} expandButtonIcon={groupIconName} onRenderTitle={(groupHeaderProps) => {
          const { group } = groupHeaderProps;
          return !group
            ? null
            : onRenderGroupTitle(initialItems.find(x => x.id === group.id));
        }}
      />)
      : onRenderGroupHeader(groupHeaderProps);
  };

  return (
    // <DetailsList
    <GroupedList
      compact={true}
      // dragDropEvents={isDnDEnabled && isEditMode && dragDropEvents}
      groupProps={{
        onRenderHeader,
        headerProps: { onToggleCollapse }
      }}
      dragDropEvents={editMode && dragDropEvents}
      isHeaderVisible={false}
      onRenderCell={onRenderCell} // GroupedList only
      // onRenderRow={onRenderRow}
      cellStyleProps={{
        cellLeftPadding: 30,
        cellRightPadding: 0,
        cellExtraRightPadding: 0
      }}
      items={items}
      groups={groups}
      columns={columns}
      selectionMode={SelectionMode.none}
      layoutMode={DetailsListLayoutMode.justified}
      {...otherProps}
    />
  );

}

export default RichList;